export default function AdminUsersPage() {
  return <div>Admin Users - Coming Soon</div>;
}
